// extracted by mini-css-extract-plugin
export default {"productGrid":"iZ-z","centerLink":"jZ-z","productSection":"kZ-z","item":"lZ-z","ctaButton":"mZ-z"};